/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type useCommentSeenEnabledLocal = {
    readonly enableCommentSeen: boolean;
    readonly " $refType": "useCommentSeenEnabledLocal";
};
export type useCommentSeenEnabledLocal$data = useCommentSeenEnabledLocal;
export type useCommentSeenEnabledLocal$key = {
    readonly " $data"?: useCommentSeenEnabledLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"useCommentSeenEnabledLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useCommentSeenEnabledLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enableCommentSeen",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '2ee52cac06a320e63b37b781960f5f3a';
export default node;
